import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalApi from "../../utils/GlobalApi";
import Configs from "../../constants/Configs";
export default function Securities(props) {
  const { open, isModel, btn } = props;
  const [massage, setMassage] = useState("");
  const handleClose = (type) => {
    isModel(!open);
  };
  useEffect(() => {
    GlobalApi.get(Configs.baseAPIURL03 + "/constant/securities")
      .then((res) => {
        setMassage(res?.data?.Data?.detail);
      })
      .catch((error) => {});
  });
  return (
    <Dialog open={open}>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="font-title text-left font-22"
          dangerouslySetInnerHTML={{
            __html: massage,
          }}
        />
      </DialogContent>
      <DialogActions
        style={{
          paddingTop: "35px",
        }}
      >
        <Button onClick={() => handleClose("")} className="btn-next font-20">
          {btn}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
